var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "lv-outage-content",
      class: {
        "lv-outage-content--list-view": _vm.outagePageView === "list",
      },
    },
    [
      _vm.filterOption != "lv"
        ? [
            _c("span", {
              staticClass: "lv-outage-content__content",
              domProps: { innerHTML: _vm._s(_vm.lvOutageHVContent) },
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "lv-outage-content__link",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.toggleLvTab.apply(null, arguments)
                  },
                },
              },
              [_vm._v("individual outages by suburb.")]
            ),
          ]
        : [
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.lvOutageLVContent) },
            }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("table", { staticClass: "lv-outage-content__table" }, [
              _c("tr", [
                _c("td", [_vm._v("Total open incidents:")]),
                _vm._v(" "),
                _c("td", [_vm._v(" " + _vm._s(_vm.calcTotalOpenIncidents))]),
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "lv-outage-content__tr--line" }, [
                _c("td", [_vm._v("Total closed incidents:")]),
                _vm._v(" "),
                _c("td", [_vm._v(" " + _vm._s(_vm.calcTotalClosedIncidents))]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("Total overall incidents:")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.calcTotalOpenIncidents +
                          _vm.calcTotalClosedIncidents
                      )
                  ),
                ]),
              ]),
            ]),
          ],
      _vm._v(" "),
      _vm.lvOutageSelectedLocation != null
        ? _c("div", { staticClass: "c-outages-search__information" }, [
            _c("span", { staticClass: "c-outages-search__results" }, [
              _vm._v(
                _vm._s(_vm.getFilteredLVOutagesGeoJson.length) +
                  " of\n      " +
                  _vm._s(_vm.getLVOutagesGeoJson.length) +
                  " results showing\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "c-outages-search__clear",
                on: { click: _vm.clearAllFilters },
              },
              [_vm._v("CLEAR\n    ")]
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }